import React, { useState,useRef,useEffect,createContext,useContext } from 'react'
import ReactDOM from 'react-dom/client'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, Navigate, Await, BrowserRouter, Route, Routes, NavLink, useNavigate, useLocation, useOutlet,useParams} from 'react-router-dom'
import axios from 'axios'
import { render } from 'react-dom'
import './scss/style.css'
import { Hero, Footer } from './component'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import { Login, SignUp, PlotGenerator, Test, LinearGenerator, CvGenerator, LoginWithDifferentDB, 
   PieChartGenerator, GraphingGenerator, SearchFilterTool, SearchFilterTool2 } from './component'
import { IoIosMenu } from 'react-icons/io'
import { BiChevronsRight } from 'react-icons/bi'
import { VscCircleLargeFilled } from 'react-icons/vsc'
import { IoCloseOutline } from 'react-icons/io5'
const APIURL1=process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV1}` : `${process.env.REACT_APP_DB_ENV_TEST1}`
const AuthContext = createContext()
export const AuthProvider = ({children}) => {
   const [shoppingCart2, setShoppingCart2] = useLocalStorage('shopping-cart', [])
   const [user2, setUser2] = useLocalStorage('user', null)
   const [auth2FA2, setAuth2FA2] = useState(null)
   const navigate = useNavigate()
   const shoppingCart1 = async (x) => {
     if (x==[]){
          window.localStorage.removeItem('shopping-cart')
     }else{
          setShoppingCart2(x)
     }
   }  
   const login = async (x) => {
     setUser2(x)
     navigate('/main')
   }  
   const autoLogin = async (data) => {
     setUser2(data)
     setAuth2FA2('true')
   }  
   const auth2FA1 = async (x) => {
     setAuth2FA2('true')
     navigate('/react', { replace: true })
   }
   const logout = () => {
     setUser2(null)
     setAuth2FA2(null)
     localStorage.removeItem('token')
     localStorage.removeItem('user')
      window.location.replace(window.location.origin);
   }
   const value = useMemo(
     () => ({
       shoppingCart2,
       user2,
       auth2FA2,
       shoppingCart1,
       login,
       autoLogin,
       logout,
       auth2FA1,
     }),
     [shoppingCart2, user2, auth2FA2]
   )
   return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
export const useAuth = () => {return useContext(AuthContext)} 
export default function App() {
  const [selectedPage4, setSelectedPage4] = useState('All')
  const selectedPage3=(x)=>{setSelectedPage4(x)}
  return (
    <div className='App'>
      <Routes>
        <Route element={<MainLayout selectedPage2={selectedPage3}/>}>
        <Route path='/' element={<Main selectedPage5={selectedPage4}/>}/>
        <Route path='/login' element={<Login selectedPage5={selectedPage4}/>}/>
        <Route path='/signup' element={<SignUp selectedPage5={selectedPage4}/>}/>
        <Route path='/account-activate/:verificationcode' element={<ACActivate />}/>
        </Route>
        <Route path='' element={<ProtectedLayout selectedPage2={selectedPage3}/>}>
         <Route path='/finance' element={<Main selectedPage5={selectedPage4}/>}/>
        </Route>
      </Routes>
    </div>
  )
}
export const pages=[
{
  ttl:'All',
  page:<>
  <Container maxWidth="md">
  <WorkSample/>
  </Container>
  <Container maxWidth="md" id='contact'>
  <DevCookBooks />
  </Container>
  <Container maxWidth="md" id='contact'>
  <Profile />
  </Container>
  <Container maxWidth="md" id='contact'>
    <Contact />
  </Container>
  </>
},
{
  ttl: 'Profile',
  page: <><Profile /></>
},
{
  ttl: 'Dev CookBooks',
  page: <><DevCookBooks /></>
},
{
  ttl: 'Work Sample',
  page: <><WorkSample /></>
},
// {
//   ttl: 'Tutorial',
//   page: <Container maxWidth="md" id='tutorials'>
//   <Tutorial />
// </Container>
// },
{
  ttl: 'Contact',
  page: <Container maxWidth="md" id='contact'
  ><Contact /></Container>
}
]
export const ProtectedLayout=({selectedPage2}) => {
  const outlet = useOutlet()
  return(
    <><b>logined page</b><br/>
    {outlet}</>
  )
}
export const MainLayout=({selectedPage2}) => {
    //  const { user2 } = useAuth()
  const outlet = useOutlet()
  let params = useParams()
  const [menu, setMenu] = React.useState(false)
  const [selectedPage1, setSelectedPage1] = useState('All')
  const onClick2Close = () => {
    setMenu(!menu)
  }
  const onClick2PagePc=(ttl)=>{
    setSelectedPage1(ttl)
    selectedPage2(ttl)
  }
  const onClick2PageMobile=(ttl)=>{
    setMenu(!menu)
    setSelectedPage1(ttl)
    selectedPage2(ttl)
  }
     return (
       <>
        <header className='header'>
        <Container maxWidth="md">
          <nav className='z-[10001] nav-container w-full flex justify-between'>
            <div className='w-fit'>
            <button onClick={()=>onClick2PagePc('All')} className='mb-[2px] nav-page-ttl-active bitter font-light'
              style={{
                textDecoration: 'none', color: '#888784', cursor: 'default', border: 'none',
                backgroundColor: 'transparent'
              }}><h1>Portfolio<span className='ml-[2px]'>Kaede Nakashima</span></h1></button>
            </div>
            <div className='nav w-fit'>
               {/* margin: '2em 8px auto', border: 'none' */}
              {pages.filter((x, i) => i > 0).map((x, i) => (<button
                key={i}
                onClick={()=>onClick2PagePc(x.ttl)}
                className={`text-[12px] bitter cursor-default mt-auto mb-[4px] mr-[8px] ${selectedPage1==x.ttl?'nav-page-ttl-active':'nav-page-ttl'}`}
                style={{
                  textAlign:'center', textDecoration:'none', color: '#888784',fontWeight: '100',backgroundColor: 'transparent',
                }}
              >{x.ttl}</button>
              ))}
              {/* <RouterLink to='/login'><div className='pl-[8px] pr-[8px] pt-[4px] pb-[4px] text-[9px] ml-[auto] mr-[2px] mt-[12px] text-white bitter bg-[#414c75] hover:bg-[#365c88]  cursor-default'>Login</div></RouterLink>
              <RouterLink to='/signup'><div className='pl-[8px] pr-[8px] pt-[4px] pb-[4px] mr-[8px] text-[9px] mt-[12px] text-white bitter bg-[#B5B5B5] hover:bg-[#b5b5b58f] cursor-default'>Sign Up</div></RouterLink> */}
              
            </div>
            <nav className="navbar md:hidden">
              <button type="button" className="nav-btn" onClick={onClick2Close}>
                <IoIosMenu />
              </button>
            </nav>
            <aside className={`md:hidden sidebar ${menu? 'show-sidebar' : ''}`}>
              <IoCloseOutline className="close-btn" menu={menu} onClick={onClick2Close}/>
              <div className='sp-nav-container'>
                {pages.map((x, i) => (<button
                  key={i}
                  onClick={()=>onClick2PageMobile(x.ttl)}
                  className={selectedPage1 === x.ttl ? 'nav-page-ttl-active' : undefined}
                  style={{
                    textAlign: 'center', textDecoration: 'none', color: '#888784',
                    fontWeight: '300', margin: '2em 8px auto', cursor: 'default', border: 'none',
                    backgroundColor: 'transparent', fontFamily: 'Bitter', fontSize: '14px'
                  }}
                >{x.ttl}</button>
                ))}
              </div>
            </aside>
          </nav>
        </Container>
        </header>
          {outlet}
          <Footer />
       </>
     )
}
export function ACActivate(){
  const [activated, setActivated]=useState('loading')
  let params = useParams()
  useEffect(() => {
    if(activated=='loading'){
          activate()
        }
  })
  const activate = async() =>{
    try {
      const {data:res}=await axios.post(`${APIURL1}/confirm`, {'confirm':params.verificationcode})
      setActivated(res.msg)
    } catch (err) {
      console.error(err);
    }
  }
  return(
    <div className='flex w-full h-[70vh]'><div className='m-auto'>{activated=='loading'?'loading..':<>{activated=='activated'?'Your account has been activated.':'404 page error'}</>}</div></div>
  )
}
export function Main({selectedPage5}){
  const [selectedPage6, setSelectedPage6] = useState('all')
  useEffect(() => {
    setSelectedPage6(selectedPage5)
  }, [selectedPage5]);
  return (
    <div className='App'>
      <section className='top-banner-container' id='home'>
        <Hero />
      </section>
      {pages.map((x,i)=>x.ttl==selectedPage6&&<div key={i}>{x.page}</div>)}
    </div>
  )
}
const SectionTitle=({title})=>{
  return (
    <h2 className='section-title'>{title}</h2>
  )
}
function WorkSample(){
  const [selectedItem, setSelectedItem] = useState('Stock')
  const [item, setItem] = useState(0)
  const [move, setMove]=useState(false)
  const [xi, setXi]=useState(0)
  const [xf, setXf]=useState(0)
  const [changedItem, setChangedItem]=useState(false)
  const yCur1 = useRef(null)
  const [yCur2, setYCur2] = useState(0)
  const [yCurUpdate4, setYCurUpdate4] = useState('')
  const yCurUpdate3=(x)=>{setYCurUpdate4(x)}
  
  const workSamples = [
    // {
    //   ttl:'Plot Generator',
    //   item: <PlotGenerator/>
    // },
    // {
    //   id:'sample-contents-container-007',
    //   ttl: 'Img/Doc Generator',
    //   item: <CvGenerator />
    // },
    {
      id:1,
      ttl: 'Stock',
      item: <LinearGenerator yCurUpdate2={yCurUpdate3} />
    },
    // {
    //   id:2,
    //   ttl: 'Cv',
    //   item: <CvGenerator yCurUpdate2={yCurUpdate3} />
    // },
    {
      id:3,
      ttl: 'Account Manage/Token Expirery Timer/Login&Logout/Admin Role',
      item: <LoginWithDifferentDB />
    },
    {
      id:4,
      ttl: 'Pie Chart Generator',
      item: <PieChartGenerator yCurUpdate2={yCurUpdate3}/>
    },
    {
      id:5,
      ttl: 'Graphing Generator',
      // item: <GraphingGenerator yCurUpdate2={yCurUpdate3}/>
      item: <GraphingGenerator/>
    },
    {
      id:6,
      ttl: 'Search & Filter1',
      item: <SearchFilterTool />
    },
    {
      id:7,
      ttl: 'Search & Filter2',
      item: <SearchFilterTool2 yCurUpdate2={yCurUpdate3}/>
    },
  ]
  if(window.screen.width<850){
    useEffect(() => {
      if (yCur2==149||yCur2==126|| yCur2==0){
        setYCur2(127)
      }else{
           setYCur2(yCur1.current.offsetHeight)
      }
      },[yCur2,yCurUpdate4])
  }
  const mousestart2 = (e) => {
    setMove(true)
    setXi(e.clientX)
    setXf(e.clientX)
  }
  const mousemove2 = (e) => {
    if (move&&!changedItem){
      setXf(e.clientX)
        if(xf-xi<-200 && item!=workSamples.length-1){
          setItem(item+1)
          setChangedItem(true)
        }
        if(xf-xi>200 && item!=0){
          setItem(item-1)
          setChangedItem(true)
        }  
    }
  }
  const mouseend2 = (e) => {
    setXi(0)
    setXf(0)
    setMove(false)
    setChangedItem(false)
  }
  const touchstart2 = (e)=>{
    setMove(true)
    setXi(e.touches[0].clientX)
    setXf(e.touches[0].clientX)
  }  
  const touchmove2 = (e)=>{
    if (move){
      setXf(e.touches[0].clientX)
      if(!changedItem){
        //swipe to left
        if(xf-xi<-200 && item!=workSamples.length-1){
          setItem(item+1)
          setYCurUpdate4(setYCurUpdate4+1)
          setChangedItem(true)
          touchend2()
        }
        //swipe to right
        if(xf-xi>200 && item!=0){
          setItem(item-1)
          setYCurUpdate4(setYCurUpdate4+1)
          setChangedItem(true)
          touchend2()
        }
      }
    }
  } 
  const touchend2 = (e)=>{
    setXi(0)
    setXf(0)
    setMove(false)
    setChangedItem(false)
  }
  return (
    <>
      <Container maxWidth="md">
        <SectionTitle title='Work Samples' />
        <div 
        className='hidden'
        >{yCur2}{yCurUpdate4}</div>
      </Container>
      <Container maxWidth="lg">
        <div className='pc-worksample'>
          <div className='vertical-nav'>
            {workSamples.map((x, i) => (<button
              key={i}
              onClick={() => setSelectedItem(x.ttl)}
              className={selectedItem === x.ttl ? 'nav-item-ttl-active' : undefined}
              style={{
                textAlign: 'center', textDecoration: 'none', color: '#D9D9D9',
                fontWeight: '400', cursor: 'default', border: 'none', margin: '2px 0',
                backgroundColor: 'transparent', fontFamily: 'raleway', fontSize: '12px'
              }}
            >
              <VscCircleLargeFilled />
            </button>
            ))}
          </div>
          <div className='workSample-content'>
            {workSamples.map((x, i) => x.ttl === selectedItem && <div key={i}>{x.item}</div>)}
          </div>
        </div>
      </Container>
      <div 
      style={{height:`${yCur2<150?150:yCur2}px`}} 
      className='relative md:hidden h-[10px] ml-[10px]'>
      <div ref={yCur1} style={{display:'absolute',left:`${(xf-xi)>10||(xf-xi)<-10?`${xf-xi}px`:'0px'}`,touchAction: 'none', height:'content-fit'}} className={`absolute 
      ${move?'shadow-gray-500/30 bg-gray-50':''} rounded-[4px] border border-[#888784] shadow-md shadow-gray-500/10 m-auto pb-[26px] w-[calc(100%_-_10px)] md:w-[250px]`} 
        onMouseDown={mousestart2}
        onMouseMove={mousemove2}
        onMouseUp={mouseend2}
        onTouchStart={touchstart2}
        onTouchMove={touchmove2}
        onTouchEnd={touchend2}
      >
        {workSamples[item].item}</div>
      </div>
    </>
  )
}
function DevCookBooks(){
  return (
    <>
      <Container maxWidth="md" className='background-img-tech1'>
        <SectionTitle title='Dev CookBooks' className='first-section' />
        <div className='dev-container text-[11px]'>
          <p className='mb-4'>I own my e-commerce site and selling my code. You can check all demo by creating your account from here.</p>
          <div className='flex'><a className='m-auto' href='https://devcookbooks.com'><button className='dev-button'>Access <span className='bitter text-[13px]'>Dev Cookbooks</span></button></a></div>
        </div>
      </Container>
    </>
  )
}
function Profile(){
  return (
    <>
      <Container maxWidth="md" className='background-img-tech1'>
        <SectionTitle title='Profile' className='first-section' />
        <div className='profile-container'>
          <Box>
            <span className='tab-space'> </span>I've been working as a web developer After I learned Aesthetics at Sophia University in 2015. I am working wordwidely such as Berlin in Germany, Sydney in Australia with different background developers who's from US, Australia, Germany, China, India, and all over the places!
            <br /><br />
            <span className='tab-space'> </span>Right now, I am working on LLM project with React and python. Usually researching and developing to get acculate and better responses. 
            <br /><br />
            <span className='tab-space'> </span>From 2015 to 2020, I was focusing on creating visually attractive websites. Beautiful big pictures and Gatzby technology helped to look page nicer. Wordpress plugin also helped to create website more professional. After I invoulved to scrach UI and UX with Adobe XD, I started to prefer website  simpler and userfriendly as possile. 
            <br /><br />
            <span className='tab-space'> </span>In 2021-2025, as more as I write complicated codes, error kept bothers me and even function I coded with precicely and logically, I realise it how time consuming to understand the code and logic even for experienced web developers.
            So, I am keep updating to write short and simple codes daily. That helps me to create more and more complicated and fuctional web applications without any critical bugs and unwanted extra time to consume for understand and fix complicated codes. 
            <br /><br />
            <span className='tab-space'> </span>AI technology does helps us to give creative responses and images. To get acculate information, I think it is better to create filter by codes. But creating useful tool can be help to get more sophisticated AI.I am excited to see the new future with using AI technologies!
            <br /><br />
            <span className='tab-space'> </span>If you have any questions about my web pages or code, please feel free to reach out to me from contact form.
            <br />
          </Box>
        </div>
      </Container>
      <Container maxWidth="md" className='background-img-tech2'>
        <SectionTitle title='Development Skills' />
        <p className='text-[11px]'>Here are tools and open source libraries I use for creating modern websites.<br />
          <div className='mt-[2px] mb-[16px] dev-skills italic'>
            ・Implement design to code.<br />
            ・Construct responsive web page with different devices.
          </div>
          <div className='skill-list-container text-[11px]'>
            <div>
              <b>Frontend</b>
              <div className='ml-[16px] mr-[16px] flex md:flex-col md:ml-[0px] md:mr-[0px]'>
                <div className='inline-block md:block'>Javascript</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>React</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>TypeScript</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Tailwind</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Gatsby</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Graph QL</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Apollo</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Redux</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>MDX</div>
              </div>
            </div>
            <div>
              <b>Backtend</b>
              <div className='ml-[16px] mr-[16px] w-full md:flex-col md:ml-[0px] md:mr-[0px]'>
                <div className='inline-block md:block'>Python</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Node.js</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Pytorch</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>TensorFlow</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>OpenAI</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Claude</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>HuggingFace</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Mistral</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Langchain</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Jupyter lab</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Google Colab</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>OCR</div>
              </div>
            </div>
            <div>
              <b>UI</b>
              <div className='ml-[16px] mr-[16px] md:flex-col md:ml-[0px] md:mr-[0px]'>
                <div className='inline-block md:block'>Material UI</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Rebass</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>react-spring</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Algoria</div>
              </div>
            </div>
            <div>
              <b>Database</b>
              <div className='ml-[16px] mr-[16px] md:flex-col md:ml-[0px] md:mr-[0px] md:mb-[8px]'>
                <div className='inline-block md:block'>JSON</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>MongoDB</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Firebase</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>AWS DynamoDB</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>AWS Lambda</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>PostgresSQL</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>MySQL</div>
              </div>
              <b className='mt-[8px]'>Testing</b>
              <div className='ml-[16px] mr-[16px] md:flex-col md:ml-[0px] md:mr-[0px] md:mb-[8px]'>
                <div className='inline-block md:block'>Jest</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Cypress</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Tetsing Lobrary</div>
              </div>
              <b className='mt-[8px]'>Others</b>
              <div className='ml-[16px] mr-[16px] md:flex-col md:ml-[0px] md:mr-[0px]'>
                <div className='inline-block md:block'>Git</div>
                <div className='inline-block md:block md:hidden'>/</div>
                <div className='inline-block md:block'>Docker</div>
              </div>
            </div>
          </div>
        </p>
      </Container>
    </>
  )
}
function Contact(){
  return (
    <>
      <Container maxWidth="md" className='background-img-tech1'>
        <SectionTitle title='Contact' />
        <div className='contact-container'>
          <form action='https://formspree.io/f/maypalap' method='POST'>
            <div className='contact-input-container'>
              <input
                type='email'
                name='email'
                placeholder='email'
                className='contact-email'
              />
              <textarea
                name='message'
                rows='5'
                placeholder='message'
                className='contact-message'
              >
              </textarea>
              <div className='contact-submit-container'>
                <button type='submit' className='contact-submit'>Send</button>
              </div>
            </div>
          </form>
        </div>
      </Container>
    </>
  )
}
const root=ReactDOM.createRoot(document.getElementById('root'))
root.render(
     <BrowserRouter>
      <App /> 
     </BrowserRouter>
)
